var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"jumbo"},[_c('div',{staticClass:"jumbo-wrapper"},[_c('div',{staticClass:"jumbo-figure"},[_c('h1',[_vm._v(_vm._s(_vm.titulo)),_c('small',[_vm._v(_vm._s(_vm.bajada))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }